import { AsyncState, unloadedAsyncState, Updater } from "widgets-for-react"
import { CompanyState, initialCompanyState } from "../../forms/company/companyState"
import { initialPaymentMethodState, PaymentMethodState } from "../../forms/paymentMethod/paymentMethodState"
import { initialPersonalInfoState, PersonalInfoState } from "../../forms/personalInfo/personalInfoState"
import { initialSubscriptionSelectorState, SubscriptionSelectorState } from "../../forms/subscriptionSelector/subscriptionSelectorState"
import { UserData } from "../subscriptionState"

export type NewSubscriptionState = Partial<{
  invoiceToCompany:boolean 
}> & {
  step:1 | 2 | 3
  personalInfoState:PersonalInfoState
  companyState:CompanyState,
  paymentMethodState:PaymentMethodState,
  subscriptionSelectorState:SubscriptionSelectorState,
  termsAndConditions?: boolean,
  checkVATState: AsyncState<boolean>,
  isValid():boolean,
}

export const initialNewSubscriptionState = (userData?:UserData) : NewSubscriptionState => ({
  step:1,
  personalInfoState:initialPersonalInfoState(userData),
  companyState:initialCompanyState(userData),
  paymentMethodState:initialPaymentMethodState,
  subscriptionSelectorState:initialSubscriptionSelectorState(),
  termsAndConditions: undefined,
  checkVATState: unloadedAsyncState(),
  isValid:function(this:NewSubscriptionState) { 
    if (this.step == 1)
      return this.subscriptionSelectorState.isValid()
    if (this.step == 2)
      return (this.invoiceToCompany != true || this.companyState.isValid()) && this.personalInfoState.isValid(true) 
    return this.paymentMethodState.isValid() && this.termsAndConditions === true
  }
})

export const newSubscriptionInputUpdaters = {
  nextStep:() : Updater<NewSubscriptionState> =>
    s => ({...s, step:s.step == 1 ? 2 : s.step == 2 ? 3 : s.step}),
  prevStep:() : Updater<NewSubscriptionState> =>
    s => ({...s, step:s.step == 3 ? 2 : s.step == 2 ? 1 : s.step}),
  invoiceToCompany:(u:Updater<NewSubscriptionState["invoiceToCompany"]>) : Updater<NewSubscriptionState> =>
    s => ({...s, invoiceToCompany:u(s.invoiceToCompany)}),
  companyState:(u:Updater<NewSubscriptionState["companyState"]>) : Updater<NewSubscriptionState> =>
    s => ({...s, companyState:u(s.companyState)}),
  paymentMethodState:(u:Updater<NewSubscriptionState["paymentMethodState"]>) : Updater<NewSubscriptionState> =>
    s => ({...s, paymentMethodState:u(s.paymentMethodState)}),
  termsAndConditions: (u: NewSubscriptionState["termsAndConditions"]) =>
    (s : NewSubscriptionState) : NewSubscriptionState => ({ ...s, termsAndConditions: u }),
  personalInfoState:(u:Updater<NewSubscriptionState["personalInfoState"]>) : Updater<NewSubscriptionState> =>
    s => ({...s, personalInfoState:u(s.personalInfoState)}),
  subscriptionSelectorState:(u:Updater<NewSubscriptionState["subscriptionSelectorState"]>) : Updater<NewSubscriptionState> =>
    s => ({...s, subscriptionSelectorState:u(s.subscriptionSelectorState)}),
 checkVATState:(u:Updater<NewSubscriptionState["checkVATState"]>) : Updater<NewSubscriptionState> =>
    s => {
      const n = u(s.checkVATState); 
      if (n.kind == "loaded" && n.value === false) {
        const authMain = document.getElementById("auth__main")
        if (authMain != null) {
          const errorBox = document.getElementById('auth__error-box')
          if (errorBox != null) authMain.scrollTo({top: errorBox.offsetTop, behavior: 'smooth'})
          else authMain.scrollTo({top: 0, behavior: 'smooth'})
        }
      }

      // If VAT check returns success, go to step 3, otherwise stay on step 2
      return ({...s, checkVATState:n, step: n.kind == "loaded" && n.value ? 3: 2})
  }}